import axios from 'axios';

type Variables = {
  name: string;
  description: string;
};

export const fetchVariables = (): Promise<Variables[]> =>
  axios.get(`/variables`).then((data) => data.data.payload.list);
